import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.searchValue = ''
      this.publishStatus = ''
      this.top = ''
    }
  }
}
export default searchFrom
